import { render, staticRenderFns } from "./BaseForm.vue?vue&type=template&id=3b88f9a6"
import script from "./BaseForm.vue?vue&type=script&lang=js"
export * from "./BaseForm.vue?vue&type=script&lang=js"
import style0 from "./BaseForm.vue?vue&type=style&index=0&id=3b88f9a6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports